import { getRequest, putRequest, postRequest } from "../../axios/axios";
import URL from "../../axios/constant";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getUserDashboardTemplate = createAsyncThunk(
  "dashboard/getUserDashboardTemplate",
  async () => {
    const token = localStorage.getItem("token");

    return new Promise((resolve, reject) => {
      getRequest(URL.GET_USER_DASHBOARD_TEMPLATE.url, token)
        .then((data) => {
          if (data.data.success) resolve(data.data);
        })
        .catch((err) => {
          if (err.response) reject(err.response.data.message);
          else reject(err);
        });
    });
  }
);

export const updateUserDashboardTemplateOrder = createAsyncThunk(
  "dashboard/updateUserDashboardTemplateOrder",
  async (data) => {
    const token = localStorage.getItem("token");
    return new Promise((resolve, reject) => {
      putRequest(URL.UPDATE_USER_DASHBOARD_TEMPLATE_ORDERS.url, token, data)
        .then((data) => {
          if (data.data.success) resolve(data.data);
        })
        .catch((err) => {
          if (err.response) reject(err.response.data.message);
          else reject(err);
        });
    });
  }
);
export const updateUserDashboardTemplateVisibility = createAsyncThunk(
  "dashboard/updateUserDashboardTemplateVisibility",
  async (data) => {
    const token = localStorage.getItem("token");
    return new Promise((resolve, reject) => {
      putRequest(URL.UPDATE_USER_DASHBOARD_TEMPLATE_VISIBILITY.url, token, data)
        .then((data) => {
          if (data.data.success) resolve(data.data);
        })
        .catch((err) => {
          if (err.response) reject(err.response.data.message);
          else reject(err);
        });
    });
  }
);

export const fetchTotalProfitBeforeTaxes = createAsyncThunk(
  "dashboard/fetchTotalProfitBeforeTaxes",
  async (data) => {
    const token = localStorage.getItem("token");

    return new Promise((resolve, reject) => {
      getRequest(URL.FETCH_TOTAL_PROFIT_BEFORE_TAXES.url, token, data)
        .then((data) => {
          if (data.data.success) resolve(data.data);
        })
        .catch((err) => {
          if (err.response) reject(err.response.data.message);
          else reject(err);
        });
    });
  }
);

export const fetchTotalPaidAndSentInvoices = createAsyncThunk(
  "dashboard/fetchTotalPaidAndSentInvoices",
  async (data) => {
    const token = localStorage.getItem("token");

    return new Promise((resolve, reject) => {
      getRequest(URL.FETCH_TOTAL_PAID_AND_SENT_INVOICES.url, token, data)
        .then((data) => {
          if (data.data.success) resolve(data.data);
        })
        .catch((err) => {
          if (err.response) reject(err.response.data.message);
          else reject(err);
        });
    });
  }
);

export const fetchTotalDoneAndTodoTasks = createAsyncThunk(
  "dashboard/fetchTotalDoneAndTodoTasks",
  async (data) => {
    const token = localStorage.getItem("token");

    return new Promise((resolve, reject) => {
      getRequest(URL.FETCH_TOTAL_DONE_AND_TODO_TASKS.url, token, data)
        .then((data) => {
          if (data.data.success) resolve(data.data);
        })
        .catch((err) => {
          if (err.response) reject(err.response.data.message);
          else reject(err);
        });
    });
  }
);

export const fetchCompletedAndActiveProjects = createAsyncThunk(
  "dashboard/fetchCompletedAndActiveProjects",
  async (data) => {
    const token = localStorage.getItem("token");

    return new Promise((resolve, reject) => {
      getRequest(URL.FETCH_TOTAL_COMPLETED_AND_ACTIVE_PROJECTS.url, token, data)
        .then((data) => {
          if (data.data.success) resolve(data.data);
        })
        .catch((err) => {
          if (err.response) reject(err.response.data.message);
          else reject(err);
        });
    });
  }
);

export const fetchTotalAgreements = createAsyncThunk(
  "dashboard/fetchTotalAgreements",
  async (data) => {
    const token = localStorage.getItem("token");

    return new Promise((resolve, reject) => {
      getRequest(URL.FETCH_AGREEMENTS_FOR_DASHBOARD.url, token, data)
        .then((data) => {
          if (data.data.success) resolve(data.data);
        })
        .catch((err) => {
          if (err.response) reject(err.response.data.message);
          else reject(err);
        });
    });
  }
);

export const fetchRecentTransactions = createAsyncThunk(
  "dashboard/fetchRecentTransactions",
  async (data) => {
    const token = localStorage.getItem("token");

    return new Promise((resolve, reject) => {
      getRequest(URL.FETCH_RECENT_TRANSACTIONS.url, token, data)
        .then((data) => {
          if (data.data.success) resolve(data.data);
        })
        .catch((err) => {
          if (err.response) reject(err.response.data.message);
          else reject(err);
        });
    });
  }
);

export const fetchTimerActivities = createAsyncThunk(
  "dashboard/fetchTimerActivities",
  async (data) => {
    const token = localStorage.getItem("token");

    return new Promise((resolve, reject) => {
      getRequest(URL.FETCH_TIMER_ACTIVITIES.url, token, data)
        .then((data) => {
          if (data.data.success) resolve(data.data);
        })
        .catch((err) => {
          if (err.response) reject(err.response.data.message);
          else reject(err);
        });
    });
  }
);

export const fetchNotes = createAsyncThunk("dashboard/fetchNotes", async () => {
  const token = localStorage.getItem("token");

  return new Promise((resolve, reject) => {
    getRequest(URL.FETCH_NOTES.url, token)
      .then((data) => {
        if (data.data.success) resolve(data.data);
      })
      .catch((err) => {
        if (err.response) reject(err.response.data.message);
        else reject(err);
      });
  });
});

export const updateNotes = createAsyncThunk(
  "dashboard/updateNotes",
  async (data) => {
    const token = localStorage.getItem("token");

    return new Promise((resolve, reject) => {
      postRequest(URL.UPDATE_NOTES.url, token, data)
        .then((data) => {
          if (data.data.success) resolve(data.data);
        })
        .catch((err) => {
          if (err.response) reject(err.response.data.message);
          else reject(err);
        });
    });
  }
);
